import { createAsyncAction, createStandardAction, } from 'typesafe-actions';

import * as types from './types';
import { repositories, } from 'api';
import { BasicApiException, } from 'common/types';

export const fetchMe = createAsyncAction(
    types.FETCH_ME_REQUEST,
    types.FETCH_ME_SUCCEEDED,
    types.FETCH_ME_FAILED,
)<any, repositories.MeType, BasicApiException<types.MeErrorType>>();

export const updateMeCarts = createStandardAction(types.UPDATE_ME_CARTS)<{ channel: string, token: string, }>();
